import { map, toLower, when } from 'ramda';

import isString from './is-string.js';

/**
 * Transforms a value into lower case only if it's a `string`.
 * Unlike `R.toLower` this function never throws.
 * @function
 * @see https://ramdajs.com/docs/#toLower
 * @template {string | any} T
 * @param {T} value The value to transform.
 * @returns {Lowercase<T>} A string transformed into lower case or the input as-is
 *  if `value` is already a string.
 */
export const safeLower = when(isString, toLower);

/**
 * Converts all string elements in an array or all string values in an object to lowercase.
 * @example
 *  lowerAll(['Foo', null, 'bAr', 42]) // ['foo', null, bar', 42]
 *  lowerAll({ foo: 'BAR', baz: undefined, value: 42 }) // { foo: 'bar', baz: undefined, value: 42 }
 * @function
 * @param {Array<string> | Record<string, string>} values The values to convert to lowercase.
 * @returns {Array<Lowercase<string>> | Record<string, Lowercase<string>>} All the passed in `values`, lower cased.
 */
export const lowerAll = map(safeLower);
